import {
  Button,
  useRecordContext,
  useTranslate,
  useRefresh,
} from 'react-admin';
import { useState } from 'react';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import { Tooltip } from '@mui/material';
import {
  AddCertifiedUsersModal,
  type CertifiedUsersCategory,
} from './AddCertifiedUsersModal';
import { AssigneeChoice } from '../../../utils/certifiedUsersAssignments';

export const AddCertifiedUsersRowButton = (props: {
  disabled?: boolean;
  choicesByCategoryId: Record<string, AssigneeChoice[]>;
  certifiedAssetIdsByCategoryId: Record<string, Set<string>>;
  isChoicesLoading?: boolean;
}) => {

  const record = useRecordContext();
  const translate = useTranslate();
  const refresh = useRefresh();
  const [open, setOpen] = useState(false);

  if (!record) return null;

  const categoryId = String(record.id);
  const choices = props.choicesByCategoryId[categoryId] ?? [];
  const certifiedAssetIds = props.certifiedAssetIdsByCategoryId[categoryId] ?? new Set();

  const category: CertifiedUsersCategory = {
    id: String(record.id),
    name: record.name,
    validityPeriod: record.validityPeriod,
    isDocumentaryProofRequired: record.isDocumentaryProofRequired ?? false,
  };

  const isDisabled = props.disabled
    || props.isChoicesLoading
    || choices.length === 0;

  const button = (
    <Button
      label={translate('resources.certification-categories.text.add_users')}
      onClick={() => setOpen(true)}
      startIcon={<PersonAddIcon />}
      disabled={isDisabled}
    />
  );

  return (
    <>
      {isDisabled && !props.disabled && !props.isChoicesLoading ? (
        <Tooltip title={translate('resources.certification-categories.text.all_users_already_certified')}>
          <span>{button}</span>
        </Tooltip>
      ) : (
        button
      )}
      <AddCertifiedUsersModal
        open={open}
        onClose={() => setOpen(false)}
        onComplete={() => {

          setOpen(false);
          refresh();

        }}
        categories={[category]}
        choices={choices}
        certifiedAssetIds={certifiedAssetIds}
        isChoicesLoading={props.isChoicesLoading}
      />
    </>
  );

};
